import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { addDays, startOfToday, setHours, setMinutes, isAfter } from 'date-fns';

export const getAdjustedDate = (): Date => {
  const now = new Date();
  const tenAM = setMinutes(setHours(startOfToday(), 10), 0);
  return isAfter(now, tenAM) ? addDays(startOfToday(), 1) : startOfToday();
};

interface DateStore {
  selectedDateFromStore: Date;
  setSelectedDateFromStore: (date: Date) => void;
  clearStore: () => void;
}

const useDateStore = create<DateStore>()(
  persist(
    (set) => ({
      // 🧠 Initialize with adjusted date if nothing in localStorage
      selectedDateFromStore: getAdjustedDate(),
      setSelectedDateFromStore: (date) => set({ selectedDateFromStore: date }),
      clearStore: () => set({ selectedDateFromStore: getAdjustedDate() }),
    }),
    {
      name: 'date-store',
      // 🧠 Optional: customize how it rehydrates the store from storage
      // and converts strings back to Date
      partialize: (state) => ({
        selectedDateFromStore: state.selectedDateFromStore.toISOString(),
      }),
      merge: (persistedState: any, currentState) => ({
        ...currentState,
        selectedDateFromStore: persistedState?.selectedDateFromStore
          ? new Date(persistedState.selectedDateFromStore)
          : getAdjustedDate(),
      }),
    },
  ),
);

export default useDateStore;
